import React, { useEffect, useState } from "react";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import FailureWebLogo from "../../assets/svg/web-failure-otp.svg";
import FailureMobLogo from "../../assets/svg/mob-failure-otp.svg";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import { useDispatch, useSelector } from "react-redux";
 
import { AppDispatch } from "../../store/store";
import { showToast } from "../../components/Toast";
import { updateLoading } from "../../store/reducers/loader";
import { fetchPaymentStatus, handleInitiatePayment } from "../../store/reducers/authentication/apiThunk";
 

const PaymentFailure = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [params, setParams] = useState<any>({});
  const [successData, setSuccessData] = useState({});

  let failedUpdate: boolean;
  let paymentData: string;

   useEffect(() => {
    const queryParams = getQueryParams();
    setParams(queryParams);
    if (!queryParams?.isVerified) {
      navigate(ROUTE_PATH.WELLNESS);
    }
  }, []);

  
  useEffect(() => {
    const queryParams = getQueryParams();
    paymentData = queryParams?.paymentData;
    failedUpdate = queryParams?.failedUpdate;
     statusAPI();
  }, []);
  

  const statusAPI = async () => {
    if (!failedUpdate) {
      try {
        const res = await dispatch(
          fetchPaymentStatus(paymentData)
        ).unwrap(); // Unwraps to return raw result or throw error
        if (res?.status === 1) {
          localStorage.setItem("paymentFailedStatus", "true");
          localStorage.setItem("transactionTimer", "20000");
          setSuccessData(res?.data);
        }
      } catch (error) {
        localStorage.setItem("paymentFailedStatus", "false");
        localStorage.setItem("transactionTimer", "20000");
        // showToast("Something went wrong", "error");
        console.error("Error saving user data:", error);
      }
    } else {
      localStorage.setItem("transactionTimer", "20000");
    }
  };

  const paymentInitiate = async () => {
    const data = {
      firstName: params?.name,
      lastName: params?.lastName,
      productInfo: "ProSure",
      amount: Number(params?.totalPrice),
      email: params?.email,
      phone: params?.mobile,
      surl: window.location.origin + ROUTE_PATH.SUCCESS_PAYMENT,
      furl: window.location.origin + ROUTE_PATH.FAILURE_PAYMENT,
      prosureCustomerId: params?.prosureCustomerId,
    };
    try {
      const res = await dispatch(handleInitiatePayment(data)).unwrap(); // Unwraps to return raw result or throw error
      if (res?.status === 1) {
        setTimeout(() => {
          navigate(ROUTE_PATH.PAYMENT);
        }, 3000);
      }
    } catch (error) {
      showToast("Something went wrong", "error");
    }
  };


  function getQueryParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const paramsRaw = Object.fromEntries(urlSearchParams.entries());
    return {
      isVerified: paramsRaw.isVerified === "true",    
      failedUpdate: paramsRaw.failedUpdate === "true",
      paymentData: paramsRaw.paymentData,                
      name: paramsRaw.name,
      email: paramsRaw.email,
      mobile: paramsRaw.mobile,
      partnerCode: paramsRaw.partnerCode,
      prosureCustomerId: paramsRaw.prosureCustomerId,
      lastName: paramsRaw.lastName,
      totalPrice: paramsRaw.totalPrice ? Number(paramsRaw.totalPrice) : 0,
    };
  
  }

  return (
    <div className="flex items-center justify-center w-[100%] h-[100vh] bg-bg-color-3 sm:bg-bg-color-5 relative">
      <div className="bg-bg-color-3 py-[14px] px-[16px] sm:py-[60px] sm:px-[88px] sm:rounded-[30px] bg-bg-color-3 sm:shadow-custom-light sm:w-[70%] lg:w-[60%]  xl:w-[45%]">
        <div className="flex flex-col items-center justify-center sm:mb-[36px] mb-[24px]">
          <img
            src={CoversureLogo}
            alt="CoversureLogo"
            className="hidden sm:block h-[22px]"
          />
          <img
            src={FailureWebLogo}
            alt="FailureWebLogo"
            className="hidden sm:block h-[110px] mt-[72px] mb-[22px]"
          />
          <img
            src={FailureMobLogo}
            alt="FailureMobLogo"
            className="block sm:hidden h-[60px] mb-[11px]"
          />
          <div className="sm:text-[30px] text-[16px] sm:leading-[38px] leading-[20px] font-bold text-text-color-6 ">
            Oops!
          </div>
          <div className="sm:text-[30px] text-[16px] sm:leading-[38px] leading-[20px] font-bold text-text-color-6 ">
            Payment failed.
          </div>

          <div
            onClick={() => {
              paymentInitiate();
            }}
            className="sm:text-[18px] text-[12px] sm:leading-[38px] leading-[15px] font-bold text-text-color-2 mt-[10px] underline cursor-pointer"
          >
            Try again
          </div>
        </div>
      </div>
      <div
        className="absolute bottom-0 bg-text-color-6 text-bg-color-5 w-[100%] p-[10px] text-center text-[12px] leading-[18px] font-semibold cursor-pointer block sm:hidden"
        onClick={() => {
          localStorage.clear();
          navigate(ROUTE_PATH.WELLNESS);
        }}
      >
        Restart client journey
      </div>
    </div>
  );
};

export default PaymentFailure;









 